export default __webpack_public_path__ + "static/media/login-bg.dc20b31e.png";